function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#008E00",
  fillRule: "evenodd",
  d: "M20 0c11.035 0 20 8.965 20 20s-8.965 20-20 20S0 31.035 0 20 8.965 0 20 0zm7.027 12.838a.66.66 0 00-.934 0l-8.912 8.911-4.222-4.222a.66.66 0 00-.933 0L9.833 19.72a.66.66 0 000 .933l6.882 6.882.074.064a.66.66 0 00.86-.064l11.57-11.57a.66.66 0 000-.934z"
});

var SvgAccept = function SvgAccept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/accept.49f09f38.svg";
export { SvgAccept as ReactComponent };